export default __webpack_public_path__ + "static/ThesacredPolynesianartofwayfinding-388af363fa3b455f898206cd24f09c36.jpg";